import _ from "lodash";

import type { RouteItem, RouteConfig } from "./routesObject";

class RoutesMappedClass {
  routesMapped: RouteItem[] = [];

  init(routesObject: RouteConfig) {
    this.routesMapped = _.flow(
      (obj) =>
        _.mapValues(obj, (val: RouteItem, key: string) => ({
          key: val.key || key,
          url: val.url,
          title: val.title || "",
          description: val.description,
          authTypes: val.authTypes || [],
          authTypesForbidden: val.authTypesForbidden || [],
          hideFooterOnMobile: !!val.hideFooterOnMobile,
          hideHeader: !!val.hideHeader,
          hideFooter: !!val.hideFooter,
          component: val.component,
          slug: _.kebabCase(key) || ""
        })),
      _.values
    )(routesObject);
  }

  returnRoutes(): RouteItem[] {
    return this.routesMapped;
  }
}

const RoutesInstance = new RoutesMappedClass();

export default RoutesInstance;
